import * as Endpoints from '../Entities/EndPoints'
import Axios from '../Axios'

const API = Axios.getInstance

export const getUserProfile = () => {
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_USER_PROFILE)
        .then((response) => response)
        .catch((err) => ({ err }))
}
